// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__22uw_","itemTitle":"ClientEmergencyInfo_itemTitle__xZgkV","itemText":"ClientEmergencyInfo_itemText__1zOeD"};